import { createNamespacedHelpers } from 'vuex'

const {
  mapActions: mapActionsCustomer,
  mapState: mapStateCustomer,
  mapGetters: mapGettersCustomer,
} = createNamespacedHelpers('customer')

export default ({ app, store }, inject) => {
  const customerActions = {
    $store: store,
    ...mapActionsCustomer([
      'setCustomer',
    ]),
  }

  // @todo używać getersow lub zmiana nazw, ustalic system aliasow
  const customerState = {
    $store: store,
    ...mapStateCustomer({
      customer: state => state.customer,
    }),
  }
  const customerGetters = {
    $store: store,
    ...mapGettersCustomer([
      'getCustomerEmail',
      'getCustomer',
      'getPurchaser',
    ]),
  }

  inject('customer', {
    ...customerState,
    ...customerActions,
    ...customerGetters,
  })
}
